import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import ExternalLink from '../../components/external-link';
import formatUrl from '../../services/format-url';
import styles from './text-editor-entity-link.scss';

const TextEditorEntityLink = ({ children, entityKey, contentState, theme, followLinks }) => {
  const { url } = contentState.getEntity(entityKey).getData();
  return (
    <ExternalLink className={classNames(styles.container, theme)} href={formatUrl(url)} followLinks={followLinks}>
      {children}
    </ExternalLink>
  );
};

TextEditorEntityLink.propTypes = {
  children: PropTypes.node,
  entityKey: PropTypes.string,
  contentState: PropTypes.object,
  theme: PropTypes.string,
  followLinks: PropTypes.bool,
};

export default TextEditorEntityLink;



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-entity-link.js